module.exports = __webpack_public_path__ + "static/media/500.809ff0c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/500.mp3
// module id = K4e1
// module chunks = 1